<template>
  <div>
    <BCard
      v-if="source === 'balances'"
      body-class="shadow-sm"
    >
      <div class="flex flex-row justify-between items-center">
        <div class="flex flex-row items-center">
          <span class="text-black font-semibold">{{ title }}</span>
          <img
            v-b-tooltip.hover.top="tooltip"
            :src="icon"
            alt="Komerce"
            class="ml-[5px] cursor-pointer"
            width="20"
          >
        </div>
        <img
          class="bg-[#F95031] rounded-lg p-[5px] cursor-pointer"
          :src="imagePath"
          alt="Komerce"
          width="30"
          @click="onClick"
        >
      </div>
      <BSpinner
        v-if="loading"
        small
        class="ml-1"
        variant="primary"
      />
      <div
        v-else
        class="text-black text-2xl font-semibold ml-[5px] my-1"
      >
        {{ total }}
      </div>
      <slot name="extra-content" />
    </BCard>
    <BCard
      v-else-if="source === 'decline'"
      body-class="shadow-sm"
      class="h-[200px]"
    >
      <div class="flex flex-row items-center">
        <img
          :src="imagePath"
          alt="Komerce"
          width="20"
        >
        <span class="text-black font-semibold text-md ml-[5px]">{{
          title
        }}</span>
        <img
          v-if="tooltip"
          v-b-tooltip.hover.top="tooltip"
          :src="icon"
          alt="Komerce"
          class="ml-[5px] cursor-pointer"
          width="20"
        >
      </div>
      <BSpinner
        v-if="loading"
        small
        class="ml-1"
        variant="primary"
      />
      <div v-else>
        <div class="text-black text-2xl font-semibold ml-[5px] my-1">
          {{ declineRatioText }}
        </div>
        <div class="flex mt-2">
          <div class="border-l border-gray-300 pl-1 ml-1 grid grid-cols-[auto_auto_1fr] gap-x-2 gap-y-3">
            <span class="text-black">Total Transaksi</span>
            <span class="text-black">:</span>
            <span class="text-[#34A270]">
              {{ item.total_transaction || 'N/A' }}
            </span>

            <span class="text-black">Total Decline</span>
            <span class="text-black">:</span>
            <span class="text-primary">
              {{ totalDeclineText }}
            </span>
          </div>
        </div>
      </div>
    </BCard>
    <BCard
      v-else
      body-class="shadow-sm"
      class="h-[200px]"
    >
      <div class="flex flex-row items-center">
        <img
          :src="imagePath"
          alt="Komerce"
          width="20"
        >
        <span class="text-black font-semibold text-md ml-[5px]">{{
          title
        }}</span>
        <img
          v-if="tooltip"
          v-b-tooltip.hover.top="tooltip"
          :src="icon"
          alt="Komerce"
          class="ml-[5px] cursor-pointer"
          width="20"
        >
      </div>
      <BSpinner
        v-if="loading"
        small
        class="ml-1"
        variant="primary"
      />
      <div v-else>
        <div class="text-black text-2xl font-semibold ml-[5px] my-1">
          {{ total }}
        </div>
        <div class="flex">
          <span class="text-[25px] border-r pr-[5px]" />
          <div class="ml-1">
            <div class="text-black ">
              <span>{{ platinum }}</span>
              <br>
              <span>{{ gold }}</span>
            </div>

            <div class="text-[#34A270]">
              + {{ cardDesc }}
            </div>
            <div class="text-[#AF6A13]">
              + {{ cardSubDesc }}
            </div>
          </div>
        </div>
      </div>
    </BCard>
  </div>
</template>

<script>
import { IDR } from '@/libs/currency'

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
    onClick: {
      type: Function,
      default: () => null,
    },
    icon: {
      type: String,
      default:
        'https://storage.googleapis.com/komerce/assets/icons/info-circle.svg',
    },
    source: {
      type: String,
      default: '',
    },
    imagePath: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      IDR,
    }
  },
  computed: {
    declineRatioText() {
      if (!this.item) return 'N/A'
      if (this.item.total_transaction === 0 && this.item.total_decline === 0) return 'N/A'
      return this.item.decline_ratio !== undefined && this.item.decline_ratio !== null
        ? `${this.item.decline_ratio}%`
        : 'N/A'
    },
    totalDeclineText() {
      if (!this.item) return 'N/A'
      if (this.item.total_transaction === 0 && this.item.total_decline === 0) return 'N/A'
      return this.item.total_decline !== undefined && this.item.total_decline !== null
        ? this.item.total_decline
        : 'N/A'
    },
    platinum() {
      if (this.source === 'card') {
        return `Platinum : ${IDR(this.item.total_card_fee_platinum)} (${
          this.item.total_card_platinum
        } Kartu)`
      }
      if (this.source === 'expense') {
        return `Platinum : ${IDR(this.item.total_expense_platinum)} (${
          this.item.total_expense_user_platinum
        } User)`
      }
      return ''
    },
    gold() {
      if (this.source === 'card') {
        return `Gold : ${IDR(this.item.total_card_fee_gold)} (${
          this.item.total_card_gold
        } Kartu)`
      }
      if (this.source === 'expense') {
        return `Gold : ${IDR(this.item.total_expense_gold)} (${
          this.item.total_expense_user_gold
        } User)`
      }
      return ''
    },
    total() {
      if (this.source === 'register') {
        return this.item.total_user_monthly
      }
      if (this.source === 'card') {
        return this.item.total_card
      }
      if (this.source === 'decline') {
        return this.item.total_decline
      }
      if (this.source === 'expense') {
        return IDR(this.item.total_expense, 2, 2)
      }
      if (this.source === 'balances') {
        return IDR(this.item.balance, 2, 2)
      }
      return ''
    },
    cardDesc() {
      if (this.source === 'register') {
        return `${this.item.total_user_this_week} Minggu ini`
      }
      if (this.source === 'card') {
        return `${this.item.percentage_card_new_user}% User Baru (${this.item.total_card_new_user})`
      }
      if (this.source === 'expense') {
        return `${this.item.percentage_expense_new_user}% User Baru (${this.item.total_expense_new_user})`
      }
      return ''
    },
    cardSubDesc() {
      if (this.source === 'register') {
        return `${this.item.total_user_last_week} Minggu Kemarin`
      }
      if (this.source === 'card') {
        return `${this.item.percentage_card_existing_user}% User Lama (${this.item.total_card_existing_user})`
      }
      if (this.source === 'expense') {
        return `${this.item.percentage_expense_existing_user}% User Lama (${this.item.total_expense_existing_user})`
      }
      return ''
    },
  },
}
</script>
